import {InsertableColumnInfo, TableColumnType} from 'notebook/tables/TableConstants';

import {StructuredTableColumn, TagValueStructuredTableColumn} from '../StructuredTableConstants';
import {ColumnDefinition} from './ColumnDefinitions';

function columnGroupEquals(column1: StructuredTableColumn, column2: StructuredTableColumn): boolean {
  return (
    (column1.columnGroup == null && column2.columnGroup == null) ||
    column1.columnGroup === column2.columnGroup
  );
}

function columnEquals(column1: StructuredTableColumn, column2: StructuredTableColumn): boolean {
  if (
    [TableColumnType.UNIT_REFERENCE, TableColumnType.UNIT_SELECTOR].includes(column1.columnType) &&
    [TableColumnType.UNIT_REFERENCE, TableColumnType.UNIT_SELECTOR].includes(column2.columnType)
  ) {
    return true;
  }
  return column1.columnType === column2.columnType;
}

function hasMatchingStructuredTableColumn(
  structuredTableColumns: Array<StructuredTableColumn>,
  columnToFind: StructuredTableColumn
): boolean {
  for (const column of structuredTableColumns) {
    if (columnEquals(column, columnToFind) && columnGroupEquals(column, columnToFind)) {
      if (column.columnType !== TableColumnType.TAG_VALUE) {
        return true;
      } else if (
        (column as TagValueStructuredTableColumn).tagSchemaFieldId ===
        (columnToFind as TagValueStructuredTableColumn).tagSchemaFieldId
      ) {
        return true;
      }
    }
  }

  // No matching column found
  return false;
}

export default function toInsertableColumnInfos(
  // All columns supported by the table, with column definitions included
  allSupportedColumns: Array<{
    structuredTableColumn: StructuredTableColumn;
    columnDefinition: ColumnDefinition | null;
  }>,
  structuredTableColumns: Array<StructuredTableColumn>
): Array<InsertableColumnInfo> {
  const missingSupportedColumns = allSupportedColumns.filter(
    (defaultColumn) =>
      !hasMatchingStructuredTableColumn(structuredTableColumns, defaultColumn.structuredTableColumn)
  );

  const insertableColumnInfos: Array<InsertableColumnInfo> = [];
  for (const missingColumn of missingSupportedColumns) {
    insertableColumnInfos.push({
      columnLabels: missingColumn.structuredTableColumn.name,
      columnConstraints: {
        columnDefinition: missingColumn.columnDefinition,
        structuredTableColumn: missingColumn.structuredTableColumn,
      },
    });
  }

  return insertableColumnInfos;
}
